<ion-app (click)="onHide()" [ngClass]="{ 'call-popup-app': isCallPopupRoute }">
    <div
        #pullRefreshIndicator
        class="app-pull-refresh-indicator"
    >
        <ion-spinner *ngIf="pullRefreshing" name="crescent"></ion-spinner>
        <svg
            #pullRefreshIcon
            *ngIf="!pullRefreshing"
            class="app-pull-refresh-arrow"
            viewBox="0 0 32 32"
            aria-hidden="true"
        >
            <path
                #pullRefreshArrowPath
                class="app-pull-refresh-arrow__arc"
                pathLength="100"
                d="M25.1 15.9C25.1 10.7 20.9 6.5 15.7 6.5C10.5 6.5 6.3 10.7 6.3 15.9C6.3 21.1 10.5 25.3 15.7 25.3C19.1 25.3 22.1 23.5 23.8 20.8"
            ></path>
            <path
                #pullRefreshArrowHead
                class="app-pull-refresh-arrow__head"
                d="M25.1 7.1V15.9H16.4"
            ></path>
        </svg>
    </div>
    <header id="header" *ngIf="this.userService.id != 0 && !isCallPopupRoute">
        <div class="mobile-menu" (click)="isMenuOpen ? isMenuOpen = false : isMenuOpen = true">
            <ion-icon name="menu-outline"></ion-icon>
        </div>
        <div class="title">
            <h2>{{ routeName }}</h2>
            <p>{{SubName}}</p>
        </div>
        <div class="dealership" (click)="onDealerSelectorClick()">
            <div class="circle" [class.new]="this.userService.storeAlertCount > 0">{{ this.userService.storeAlertCount }}</div>
            <h4>{{ this.userService.dealer.name }}</h4>
            <h5>{{ this.userService.dealer.city }}, {{ this.userService.dealer.province }}</h5>
        </div>
        <div class="menu">
            <div class="circle">{{ this.userService.alertCount }}</div>
            <ion-icon name="notifications-outline" (click)="onAlertClick()"></ion-icon>
            <div class="banner" [hidden]="!(showAlertBanner | async)">
                {{ showAlertBannerText | async }}
            </div>
        </div>
        <div class="user" (click)="onProfileToggle($event)">
            {{ this.userService.firstName[0] }}{{ this.userService.lastName[0] }}
            <div class="circle"></div>
        </div>
        <div class="profile" *ngIf="show.profile" (click)="onProfileClick($event)">
            <div class="profile-summary">
                <div class="profile-avatar" [class.admin-avatar]="this.userService.admin === 1">
                    {{ this.userService.firstName[0] }}{{ this.userService.lastName[0] }}
                    <span class="profile-admin-mark" *ngIf="this.userService.admin === 1" aria-hidden="true">
                        <ion-icon name="shield-checkmark"></ion-icon>
                    </span>
                </div>
                <div class="profile-identity">
                    <div class="profile-name-row">
                        <h5>{{ this.userService.firstName }} {{ this.userService.lastName }}</h5>
                        <span class="profile-role" *ngIf="this.userService.admin === 1">
                            <ion-icon name="shield-checkmark-outline"></ion-icon>
                            Admin
                        </span>
                    </div>
                    <p>{{ this.userService.email }}</p>
                </div>
            </div>
            <button class="logout" type="button" (click)="onLogoutClick()">
                <ion-icon name="log-out-outline"></ion-icon>
                Log out
            </button>
        </div>
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <path
                fill="#E9EBEC"
                d="M40.4,-59.3C48,-50,47,-32.5,54.2,-16.2C61.4,0.1,76.9,15,78.4,30.1C79.8,45.1,67.2,60.2,51.8,71.2C36.4,82.2,18.2,89.2,1.3,87.3C-15.5,85.5,-31.1,74.8,-35.1,60.1C-39.1,45.4,-31.6,26.6,-36.6,11.8C-41.6,-3.1,-59.1,-14,-63.5,-26.9C-68,-39.8,-59.3,-54.8,-46.6,-62.4C-33.8,-70,-16.9,-70.3,-0.3,-69.9C16.4,-69.6,32.7,-68.6,40.4,-59.3Z"
                transform="translate(100 100)"
            />
        </svg>
    </header>
    <nav id="navigation" *ngIf="this.userService.id != 0 && !isCallPopupRoute">
        <div class="logo">
         <img src="assets/icon/Advantage-Connect-Logo.svg" alt="Advantage Connect Logo" />
            <ion-icon name="layers"></ion-icon>
        </div>
        <ul [class.standard]="this.userService.admin != 1">
            <li class="disabled" data-tooltip="Dashboard">
                <ion-icon name="pie-chart-sharp"></ion-icon>
            </li>
                <li [routerLink]="'/conversations'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }" data-tooltip="Conversations">
                    <ion-icon name="chatbubble-ellipses-sharp"></ion-icon>
                </li>
                <li [routerLink]="'/leads'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" data-tooltip="Leads">
                    <ion-icon name="file-tray-full-sharp"></ion-icon>
                    <div class="circle" *ngIf="incomingLeadCount > 0">{{ incomingLeadCount }}</div>
                </li>
                <li [routerLink]="'/customers'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" data-tooltip="Customers">
                    <ion-icon name="person-circle-sharp"></ion-icon>
                </li>
                <!-- <li [routerLink]="'/createuser'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" data-tooltip="Create User">
                    <ion-icon name="create-outline"></ion-icon>
                </li> -->
                <li class="nav-cluster" [class.active]="isActivityCallRoute()" data-tooltip="Activity Center">
                    <ion-icon name="apps-sharp"></ion-icon>
                    <div class="circle" *ngIf="voicemailService.unreadCount > 0">{{ voicemailService.unreadCount }}</div>
                    <span class="selected-child-icon" *ngIf="isActivitiesRoute()">
                        <ion-icon name="pulse-sharp"></ion-icon>
                    </span>
                    <span class="selected-child-icon" *ngIf="isCallLogsRoute()">
                        <ion-icon name="call-sharp"></ion-icon>
                    </span>
                    <span class="selected-child-icon" *ngIf="isVoicemailRoute()">
                        <ion-icon name="recording-outline"></ion-icon>
                    </span>
                    <div class="nav-flyout">
                        <a [routerLink]="'/activities'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                            <ion-icon name="pulse-sharp"></ion-icon>
                            <span>Activities</span>
                            <ion-icon class="nav-flyout-arrow" name="chevron-forward-outline"></ion-icon>
                        </a>
                        <a [routerLink]="'/call-logs'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                            <ion-icon name="call-sharp"></ion-icon>
                            <span>Call Logs</span>
                            <ion-icon class="nav-flyout-arrow" name="chevron-forward-outline"></ion-icon>
                        </a>
                        <a [routerLink]="'/voicemail-logs'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                            <ion-icon name="recording-outline"></ion-icon>
                            <span>Voicemails</span>
                            <strong *ngIf="voicemailService.unreadCount > 0">{{ voicemailService.unreadCount }}</strong>
                            <ion-icon class="nav-flyout-arrow" name="chevron-forward-outline"></ion-icon>
                        </a>
                    </div>
                </li>
                <li [routerLink]="'/settings/general'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" data-tooltip="Settings">
                    <ion-icon name="settings-sharp"></ion-icon>
                </li>
        </ul>
        <div class="logout" (click)="onLogoutClick()" data-tooltip="Log Out">
            <ion-icon name="log-out"></ion-icon>
        </div>
    </nav>
    <div id="menu" *ngIf="isMenuOpen && !isCallPopupRoute">
        <div class="body">
            <div class="menu-top">
                <div class="menu-brand">
                    <img src="assets/icon/Advantage-Connect-Logo.svg" alt="Advantage Connect Logo" />
                    <span class="menu-title">ADVANTAGE CONNECT</span>
                </div>
                <button class="menu-close" (click)="isMenuOpen = false" aria-label="Close menu">
                    <ion-icon name="close-outline"></ion-icon>
                </button>
            </div>
            <ul [class.standard]="this.userService.admin != 1">
                <li class="nav-item disabled">
                    <ion-icon name="pie-chart-sharp"></ion-icon> Dashboard
                </li>
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
                    <a class="menu-link" [routerLink]="'/conversations'" (click)="isMenuOpen = false">
                        <ion-icon name="chatbubble-ellipses-sharp"></ion-icon> Conversations
                    </a>
                </li>
                <!-- <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="this.userService.admin == 1">
                    <a class="menu-link" [routerLink]="'/leads'" (click)="isMenuOpen = false">
                        <ion-icon name="file-tray-full-sharp"></ion-icon> Leads
                    </a>
                </li> -->
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="menu-link" [routerLink]="'/leads'" (click)="isMenuOpen = false">
                        <ion-icon name="file-tray-full-sharp"></ion-icon> Leads
                        <span class="menu-badge" *ngIf="incomingLeadCount > 0">{{ incomingLeadCount }}</span>
                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="menu-link" [routerLink]="'/customers'" (click)="isMenuOpen = false">
                        <ion-icon name="person-circle-sharp"></ion-icon> Customers
                    </a>
                </li>
                <!-- <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="menu-link" [routerLink]="'/createuser'" (click)="isMenuOpen = false">
                        <ion-icon name="create-outline"></ion-icon> CreateUser
                    </a>
                </li> -->
                <li class="nav-item" routerLinkActive="active">
                    <a class="menu-link" [routerLink]="'/settings/general'" (click)="isMenuOpen = false">
                        <ion-icon name="settings-sharp"></ion-icon> Settings
                    </a>
                </li>
                <li class="nav-item nav-group" [class.active]="isActivityCallRoute()">
                    <div class="menu-link nav-group-title">
                        <ion-icon name="apps-sharp"></ion-icon> Activity Center
                    </div>
                    <a class="menu-link nav-sub-link" [routerLink]="'/activities'" (click)="isMenuOpen = false">
                        <ion-icon name="pulse-sharp"></ion-icon> Activities
                    </a>
                    <a class="menu-link nav-sub-link" [routerLink]="'/call-logs'" (click)="isMenuOpen = false">
                        <ion-icon name="call-sharp"></ion-icon> Call Logs
                    </a>
                    <a class="menu-link nav-sub-link" [routerLink]="'/voicemail-logs'" (click)="isMenuOpen = false">
                        <ion-icon name="recording-outline"></ion-icon> Voicemails
                        <span class="menu-badge" *ngIf="voicemailService.unreadCount > 0">{{ voicemailService.unreadCount }}</span>
                    </a>
                </li>
                <li class="nav-item" (click)="onLogoutClick(); isMenuOpen = false">
                    <ion-icon name="log-out"></ion-icon> Logout
                </li>
            </ul>
        </div>
        <div class="underlay" (click)="isMenuOpen = false"></div>
    </div>
    <ion-router-outlet *ngIf="isReady"></ion-router-outlet>
    <app-context-menu *ngIf="!isCallPopupRoute" (markAsRead)="onMarkAsRead()"></app-context-menu>
</ion-app>
